/**
 * @returns {Promise<String>}
 */
export default async function getAdminVersion() {
    return this.get('/version');
}
